import { render, staticRenderFns } from "./IdPwLogin.vue?vue&type=template&id=bbc0463c&"
import script from "./IdPwLogin.vue?vue&type=script&lang=js&"
export * from "./IdPwLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports